import { createParametrics, initStateFromStartingFeatures } from "../utils/lateralizedUtils"
import { computeLateralizedFeatures } from "../utils/layerUtils"


export let LateralizedFreeRoamMode = {}

// When the mode starts this function will be called.
// The `opts` argument comes from `draw.changeMode('lotsofpoints', {count:7})`.
// The value returned should be an object and will be passed to all other lifecycle functions
LateralizedFreeRoamMode.onSetup = function (opts) {
    var state = {}

    state.options = opts

    state.roadSegments = opts.roadSegments
    state.startingFeatures = opts.startingFeatures

    this.map["dragPan"].enable()
    this.map.getCanvas().style.cursor = ""

    return state
}

LateralizedFreeRoamMode.toDisplayFeatures = function (state, geojson, display) {
    const original = this.getFeature(geojson.properties.id)
    const featureCollection = {
        type: "FeatureCollection",
        features: [{
            ...geojson,
            properties: {
                ...original?.properties,
                ...geojson.properties,
            },
        }],
    }
    const lateralizedFeatureCollection = computeLateralizedFeatures(featureCollection, this.map)
    const feature = lateralizedFeatureCollection.features[0]
    display(feature)
}

LateralizedFreeRoamMode.onTrash = function (state) {
    const defaultParametrics = initStateFromStartingFeatures(state)
    createParametrics(this, state, defaultParametrics, true, state.options.existingFeatures)
}